import { useState } from "react";
import { api } from "@/lib/api";
import { VoicePicker } from "@/components/VoicePicker";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { AudioLines, Loader2 } from "lucide-react";
import { toast } from "sonner";

export const ChangeVoiceDialog = ({ project, refresh }) => {
  const current = project.voice_style || "";
  const [open, setOpen] = useState(false);
  const [voice, setVoice] = useState(current);
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      await api.changeVoice(project.id, voice);
      await refresh();
      toast.success("All voiceovers re-recorded with the new voice");
      setOpen(false);
    } catch {
      toast.error("Couldn't change the voice. Please try again.");
    }
    setSaving(false);
  };

  return (
    <>
      <button
        data-testid="change-voice-btn"
        onClick={() => { setVoice(current); setOpen(true); }}
        disabled={project.status === "processing"}
        className="inline-flex items-center gap-1.5 hover:text-[#F59E0B] transition-colors disabled:opacity-50"
      >
        <AudioLines className="h-4 w-4" /> {current ? `${current[0].toUpperCase()}${current.slice(1)} voice` : "Original voice"} · <span className="underline underline-offset-2">Change</span>
      </button>
      <Dialog open={open} onOpenChange={(o) => !saving && setOpen(o)}>
        <DialogContent className="bg-[#1E293B] border-white/10 max-w-2xl" data-testid="change-voice-dialog">
          <DialogHeader>
            <DialogTitle className="font-display">Choose narrator voice</DialogTitle>
            <DialogDescription className="text-[#94A3B8]">
              {current ? "" : "This project uses the original voices. "}Every film voiceover and storybook narration in this project will be re-recorded.
            </DialogDescription>
          </DialogHeader>
          <VoicePicker value={voice} onChange={setVoice} />
          <Button data-testid="confirm-change-voice-btn" onClick={save} disabled={saving || !voice || voice === current}
            className="w-full bg-[#F59E0B] hover:bg-[#D97706] text-[#0F1117] font-semibold rounded-full">
            {saving ? <><Loader2 className="h-4 w-4 mr-2 animate-spin" /> Re-recording voiceovers…</> : "Re-record with this voice"}
          </Button>
        </DialogContent>
      </Dialog>
    </>
  );
};
